<template>
  <div class="register-steps">
    <div class="register-steps__title">{{ title }}</div>
    <div class="register-steps__description" v-if="description">
      {{ description }}
    </div>
    <div class="register-steps__points" v-if="stepList">
      <ul class="register-steps__points-list points-list" v-if="stepList">
        <li class="points-list__list-indicator" v-for="(i, ind) in stepList" :key="ind"
          :class="{ current: ind <= step - 1 }"></li>
      </ul>
    </div>
    <div class="register-steps__descr" v-if="stepList && step">
      {{ stepList[step - 1] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterSteps",
  props: {
    step: {
      type: Number,
      default: 1,
    },
    description: String,
    stepList: Array,
    title: String,
  },
  data: () => ({}),
  computed: {
    analyticData() {
      let browser;
      if (
        (navigator.userAgent.indexOf("Opera") ||
          navigator.userAgent.indexOf("OPR")) != -1
      ) {
        browser = "Opera";
      } else if (navigator.userAgent.indexOf("Edg") != -1) {
        browser = "Edge";
      } else if (navigator.userAgent.indexOf("YaBrowser") != -1) {
        browser = "Yandex Browser";
      } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        browser = "Chrome";
      } else if (navigator.userAgent.indexOf("Safari") != -1) {
        browser = "Safari";
      } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        browser = "Firefox";
      } else if (
        navigator.userAgent.indexOf("MSIE") != -1 ||
        !!document.documentMode == true
      ) {
        //IF IE > 10
        browser = "IE";
      } else {
        browser = "unknown";
      }
      return {
        browser: browser,
        device: this.getDeviceType(),
        os: this.getOS(),
        url: document.location.origin + document.location.pathname,
        nova_id: this.mdmId,
        user_id: this.userId,
        dpl_id: this.$route.query.access || "",
      };
    },
  },
  methods: {

    getOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
      }
      if (/android/i.test(userAgent)) {
        return "Android";
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
      }
      if (/Macintosh/i.test(userAgent)) {
        return "MacOS";
      }
      if (/Windows/i.test(userAgent)) {
        return "Windows";
      }
      if (/Linux/i.test(userAgent)) {
        return "Linux";
      }

      return "Unknown OS";
    },
    getDeviceType() {
      const userAgent = navigator.userAgent;
      if (/Mobi|Android/i.test(userAgent)) {
        return "Mobile";
      }
      if (/Tablet|iPad/i.test(userAgent)) {
        return "Tablet";
      }
      return "Desktop";
    },
    stepChange() {
      this.$axios(`/analytics/send/`, {
        method: "POST",
        data: {
          brand_name: "",
          brand_id: "",
          content_date: "",
          content_id: "",
          content_name: `${this.step} шаг`,
          content_type: "Регистрация",
          nosology_name: "",
          content_parameter: "",
          event_type: "registration step",
          url: this.analyticData.url,
          event_parameter: "",
          page_block: "",
          page_name: "Регистрация",
          page_type: "Регистрация",
          nova_id: "",
          session_id: "",
          user_id: "",
          browser: this.analyticData.browser,
          device_type: this.analyticData.device,
          dpl_id: this.$route.query.access || "",
          os: this.analyticData.os,
          utm_campaign: this.$route.query.utm_campaign || "",
          utm_content: this.$route.query.utm_content || "",
          utm_medium: this.$route.query.utm_medium || "",
          utm_source: this.$route.query.utm_source || "",
          utm_term: this.$route.query.utm_term || "",
        },
      });
    }
  },
  mounted() {
    if (this.stepList && this.stepList.length) {
      this.stepChange()
    }

  },
  watch: {
    step() {
      this.stepChange()
    },
  },
};
</script>

<style lang="scss" scoped>
.register-steps {
  width: 280px;

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;

    @media screen and (max-width: 767px) {
      font-size: 32px;
      line-height: 38px;
    }
  }

  &__points {
    margin-top: 48px;

    @media screen and (max-width: 767px) {
      margin-top: 24px;
    }
  }

  &__description {
    margin-top: 16px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 23px;
    color: #3c4242;
  }

  .points-list {
    width: 100%;
    display: flex;
    margin-bottom: 12px;

    &__list-indicator {
      width: 100%;
      height: 6px;
      margin-right: 12px;
      background-color: #ebefee;
      border-radius: 99px;
    }

    &__list-indicator:last-child {
      margin-right: 0;
    }

    &__list-indicator.current {
      background: #c4d600;
    }
  }

  &__descr {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3c4242;
  }
}
</style>